/** @jsxImportSource @emotion/react */
import moment from 'moment';
import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { useLocation } from 'react-router-dom';
import useSWR from 'swr';
// eslint-disable-next-line no-unused-vars
import tw from 'twin.macro';
import numberFormatter from '../../../utils/numberFormatter';
import { swrfetcher } from '../../../utils/swrFetcher';
import DatRangePickerAndOthers from '../../Common/DataGridFunctionalities/DatRangePickerAndOthers';
import FilterBox from '../../Common/DataGridFunctionalities/FilterBox';
import SearchBar from '../../Common/DataGridFunctionalities/SearchBar';
import DataGridViewTemp from '../../Common/DataGridViewTemp';
import TransactionCard from '../../Common/TransactionCard';

const POSTransactions = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const offset = query.get('offset');

  const [searchValue, setSearchValue] = React.useState('');
  const [status, setStatus] = React.useState('');
  // const [date, setDate] = React.useState(['', '']);
  const [day, setDay] = React.useState('Today');
  const [date, setDate] = React.useState([moment().format('yyyy-MM-DD'), null]);

  React.useEffect(() => {
    if (day === 'Today') {
      setDate([moment().startOf('day').format('yyyy-MM-DD'), null]);
    } else if (day === 'Yesterday') {
      setDate([
        moment().subtract(1, 'days').startOf('day').format('yyyy-MM-DD'),
        null,
      ]);
    } else if (day === 'This Week') {
      setDate([moment().startOf('week').format('yyyy-MM-DD'), null]);
    } else if (day === 'This Month') {
      setDate([moment().startOf('month').format('yyyy-MM-DD'), null]);
    } else if (day === 'Last Month') {
      setDate([
        moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
      ]);
    } else {
      setDate([moment().startOf('year').format('YYYY-MM-DD'), null]);
    }
  }, [day]);

  const userType = JSON?.parse(
    localStorage.getItem('userType') || sessionStorage.getItem('userType')
  ).toLowerCase();

  const tableUrl =
    userType === 'admin'
      ? `/apis/v1/bizzdesk/admin/merchant/analytics/getMerchantTransactionRecord?limit=30&offset=${
          offset || 0
        }&transMode=pos${
          !searchValue ? '' : `&searchParameter=${searchValue}`
        }${!date[0] ? '' : `&startDate=${date[0]}`}${
          !date[1] ? '' : `&endDate=${date[1]}`
        }${!status ? '' : `&status=${status}`}`
      : `/apis/bizzdesk/organization/transaction/getMerchantTransactionRecord?limit=30&offset=${
          offset || 0
        }&transMode=pos${
          !searchValue ? '' : `&searchParameter=${searchValue}`
        }${!date[0] ? '' : `&startDate=${date[0]}`}${
          !date[1] ? '' : `&endDate=${date[1]}`
        }${!status ? '' : `&status=${status}`}`;

  const countUrl =
    userType === 'admin'
      ? `/apis/v1/bizzdesk/admin/merchant/analytics/getMerchantTransactionRecord/count?limit=30&offset=${
          offset || 0
        }&transMode=pos${
          !searchValue ? '' : `&searchParameter=${searchValue}`
        }${!date[0] ? '' : `&startDate=${date[0]}`}${
          !date[1] ? '' : `&endDate=${date[1]}`
        }${!status ? '' : `&status=${status}`}`
      : `/apis/bizzdesk/organization/transaction/getMerchantTransactionRecord/count?limit=30&offset=${
          offset || 0
        }&transMode=pos${
          !searchValue ? '' : `&searchParameter=${searchValue}`
        }${!date[0] ? '' : `&startDate=${date[0]}`}${
          !date[1] ? '' : `&endDate=${date[1]}`
        }${!status ? '' : `&status=${status}`}`;

  const analyicUrl =
    userType === 'admin'
      ? `/apis/v1/bizzdesk/admin/transaction/POS/getMetrics?startDate=${
          date[0]
        }${!date[1] ? '' : `&endDate=${date[1]}`}`
      : `/apis/bizzdesk/organization/transaction/s/pos/getMetrics?startDate=${
          date[0]
        }${!date[1] ? '' : `&endDate=${date[1]}`}`;

  const token = JSON?.parse(
    localStorage.getItem('token') || sessionStorage.getItem('token')
  );

  const { data: tableData, isValidating } = useSWR(
    [tableUrl, token, 'GET'],
    ([url, USER_TOKEN, method]) => swrfetcher(url, USER_TOKEN, method)
  );

  const { data: analyticData } = useSWR(
    [analyicUrl, token, 'GET'],
    ([url, USER_TOKEN, method]) => swrfetcher(url, USER_TOKEN, method)
  );

  const { data: countValue } = useSWR(
    [countUrl, token, 'GET'],
    ([url, USER_TOKEN, method]) => swrfetcher(url, USER_TOKEN, method)
  );

  /* A data for the transactionStatsData component. */
  const transactionStatsData = [
    {
      amount: (
        <CurrencyFormat
          value={88}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total successful transactions',
      value: numberFormatter(88),
    },
    {
      amount: (
        <CurrencyFormat
          value={88}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total failed transactions',
      value: numberFormatter(88),
    },
    {
      amount: (
        <CurrencyFormat
          value={88}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
      title: 'Total Pending transactions',
      value: numberFormatter(88),
    },
  ];

  const TransPOSColumn = [
    {
      headerName: 'S/N',
    },
    {
      headerName: 'Transaction Type',
    },
    {
      headerName: 'Terminal Id',
    },
    {
      headerName: 'Merchant Name',
    },
    {
      headerName: 'Organization Name',
    },
    {
      headerName: 'Role',
    },
    {
      headerName: 'RRN',
    },
    {
      headerName: 'Transaction Ref.',
    },
    {
      headerName: 'Bank',
    },
    {
      headerName: 'Card Pan',
    },
    {
      headerName: 'Card Type',
    },
    {
      headerName: 'Currency',
    },
    {
      headerName: 'Stan',
    },
    {
      headerName: 'Auth Code',
    },
    {
      headerName: 'Amount',
    },
    {
      headerName: 'Total Charge',
    },
    {
      headerName: 'Paysure Charge',
    },
    {
      headerName: 'Organization Charge',
    },
    {
      headerName: 'Recievable Amount',
    },
    {
      headerName: 'Date/Time',
    },
    {
      headerName: 'Status',
    },
    {
      headerName: 'Response Code',
    },
    {
      headerName: 'Action',
    },
  ];

  let rows = [];
  if (tableData) {
    if (tableData?.status >= 400) {
      rows = [];
    } else {
      rows = tableData?.map((item, index) => {
        return {
          id: Number(offset || 0) + index + 1,
          type: item?.transtype,
          terminalId: item?.tid,
          merchantName: item?.fullName,
          organizationName: item?.organizationName,
          role: item?.role,
          rrn: item?.rrn,
          transactionRef: item?.ref,
          bank: item?.bank,
          cardPan: item?.panAccount,
          cardType: item?.cardType,
          currency: item?.currency,
          stan: item?.stan,
          authCode: item?.authCode,
          amountN: item?.amount,
          totalChargeN: item?.totalCharge,
          bizzDeskChargeN: item?.bizzdeskCharges,
          organizationChargeN: item?.organizationCharge,
          recievableAmountN: item?.receivableAmount,
          dateTime: item?.date,
          status: item?.status,
          responseCode: item?.response,
          action: {
            link: `/transactions/${item?.ref}`,
          },
        };
      });
    }
  }

  return (
    <>
      <div tw="grid grid-cols-2 gap-3 md:grid-cols-3 xl:( gap-5) mt-5">
        {transactionStatsData.map(({ amount, value, link, title }, index) => {
          return (
            <TransactionCard
              key={index}
              title={title}
              amount={amount}
              value={value}
              isValidating={true}
              link={link}
              hasFilter={index === 0 && day}
              setFilter={index === 0 && setDay}
            />
          );
        })}
      </div>

      <DataGridViewTemp
        link="/checkout/transactions/transactions_list/barter"
        hasMT
        title="Barter Transactions"
        rows={[]}
        columns={TransPOSColumn}
        // isValidating={isValidating}
        hasExportBtn={tableData}
        pagination
        recordCount={countValue || 0}
        page={offset / 30 + 1}
      >
        <div tw="grid grid-auto-columns[auto] gap-4 w-full xl:(flex items-center space-y-0 space-x-4)">
          <SearchBar value={searchValue} setSearchValue={setSearchValue} />
          <FilterBox
            dropdownData={['All', 'Completed', 'Failed']}
            value={status}
            setFilterValue={setStatus}
          />
          <DatRangePickerAndOthers date={date} setDate={setDate} />
        </div>
      </DataGridViewTemp>
    </>
  );
};

export default POSTransactions;
